/* eslint-disable no-unused-vars */
import $ from 'jquery';
import ParseObjectString from '@component/common/src/util/ParseObjectString';
import QuickBagRestApi from './components/QuickBagRESTApi';
import qbActions from './components/QuickBagActions';

const context = $('header[data-uri]').data('context') ? $('header').data('context') : undefined;
const viewType = (context !== undefined && context.viewType !== undefined) ? context.viewType : 'Default';
const meta = ParseObjectString.toObject($('script[data-mcom-header-meta]').html(), '{}');
const dbedHeaderRedesignEnabledExp = !!(meta && meta.properties && meta.properties.dbedHeaderRedesignEnabledExp);

/* istanbul ignore else */
if ((viewType.toLowerCase().indexOf('minimal') === -1) || dbedHeaderRedesignEnabledExp) {
  Promise.all([
    import('pageApp'),
    import(/* webpackChunkName: "quickBag" */ './scss/quick-bag/main.scss'),
    import(/* webpackChunkName: "quickBag-compact" */ './scss/quick-bag/quick-bag.scss'),
  ]).then(([PageApp]) => {
    // logic to load if bagservice proxy is loaded server-side
    const Channel = PageApp.channel ? PageApp.channel : PageApp.default.channel;
    /* istanbul ignore else */
    if ($('header').data('bagserviceproxy') !== undefined && $('header').data('bagserviceproxy') !== '') {
      Channel.trigger(qbActions.INIT);
    }
    // logic to load if bagservice proxy is loaded client-side
    Channel.on('Quickbag:load', (bagservice) => {
      /* istanbul ignore else */
      if ($('header').data('bagserviceproxy') === undefined) {
        const hostlink = $('header').data('hostlink') || undefined;
        if (hostlink) {
          $('header').data('bagserviceproxy', hostlink + bagservice);
        } else {
          $('header').data('bagserviceproxy', bagservice);
        }
        Channel.trigger(qbActions.INIT);
      }
    });
  });
}
